@if(events.length > 0) {
  <mat-expansion-panel (opened)="onPanelOpen()" (closed)="onPanelClose()" class="panel-container" #outerPanel>
    <mat-expansion-panel-header class="panel-container-inner">
      <mat-panel-title class="panel-main-title">
        <div class="vtz-badge" matBadge="{{numBallots()}}" matBadgeOverlap="false" matBadgeColor="warn" matBadgeSize="small" [matBadgeHidden]="areNoBallots()" i18n>Elections</div>
      </mat-panel-title>
      <mat-panel-description>
        {{eventsOpenState() ? '' : EventsOpenStateDescription}}
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div class="inner-accordion-container" [class.expanded]="outerPanel.expanded" [class.collapsed]="!outerPanel.expanded">
      <mat-accordion [multi]="false">
        <app-elections-item i18n-title title="Ballots"
          [openDescription]="openDescriptionBallot"
          [closedDescription]="closeDescriptionBallot" [ballots]="events"
          (selectBallot)="selectedBallot($event)"></app-elections-item>
      </mat-accordion>
    </div>
  </mat-expansion-panel>
}